import MessageControls from "pages/MessageBox/MessageControls";
import Loader from "components/ui/Loader/Loader";
import Message from "pages/MessageBox/Message";
import { useMessageBox } from "pages/MessageBox/MessageBoxContext";
import useData from "hooks/useData";
import { useEffect, useState } from "react";
import Pager from "components/ui/Pager/Pager";
import { useQuery } from "hooks/useQuery";

function ViewConversation() {
  const searchParams = useQuery();
  const currentPage = searchParams.get(`page`) || 1;

  const { conversations, setConversations, refreshConversations, selectedConversation } = useMessageBox();
  const [ isLoading, setIsLoading ] = useState(true);
  const [ conversation, setConversation ] = useState([]);
  const [ selectedMessage, setSelectedMessage ] = useState();

  const { getData } = useData();

  useEffect(() => {
      const load = async () => {
        setIsLoading(true);
        const { data } = await getData(`rest/conversation/${ selectedConversation }`);
        setConversation(data);
        setIsLoading(false);
      }

      load();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ selectedConversation ]
  );

  if (!selectedConversation) {
    return null;
  }

  if (isLoading) {
    return <Loader/>;
  }

  if (!conversation?.results?.length && conversations?.length) {
    console.warn(`Conversation ${ selectedConversation } not found`);
    return 'Selecteer een gesprek om de berichten te lezen.';
  }

  const findProfileRef = (uid) => {
    return conversation.refs.profile.find(item => item.uid === parseInt(uid));
  }

  const handleRead = (row) => {
    row.unread = null;

    const newConversations = { ...conversations };
    const readConversation = newConversations.results.find(item => parseInt(item.sender_uid) === parseInt(row.sender_uid));
    if (readConversation) {
      readConversation.unread--;
    }

    setConversations(newConversations);
  }

  const handleDeleted = (deletedRow) => {
    const newConversation = { ...conversation };
    newConversation.results = newConversation.results.filter(item => item.boxitem_id !== deletedRow.boxitem_id);
    setConversation(newConversation);

    // If this was the last message in this conversation, refresh the entire messagebox to hide the conversation
    if (newConversation.results.length <= 1) {
      refreshConversations();
    }
  }

  const content = conversation.results?.map(
    (row, index) => {
      const profile = findProfileRef(row.sender_uid);
      if (!profile) {
        console.warn(row, 'No profile found for this user');
        return null;
      }

      return <Message key={ parseInt(row.boxitem_id) }
                      id={ parseInt(row.id) }
                      created={ row.created }
                      profile={ profile }
                      message={ row.message }
                      image={ row.image }
                      isRead={ row.unread !== '1' }
                      isExpanded={ selectedMessage === parseInt(row.id) || (!selectedMessage && index === 0) }
                      onSelect={ setSelectedMessage }
                      onReplied={ refreshConversations }
                      onRead={ () => handleRead(row) }
                      onDeleted={ () => handleDeleted(row) }/>
    }
  );

  const partnerProfile = findProfileRef(selectedConversation);
  if (!partnerProfile) {
    return null;
  }

  return (
    <>
      <MessageControls profile={ partnerProfile }
                       messages={ conversation.results }/>
      <h3>Gesprek met <a href={ partnerProfile?.url } className={ `underline` }>{ partnerProfile?.title?.value }</a>
      </h3>
      { content }
      <Pager
        currentPage={ conversation.pager.current_page + 1 }
        onChange={ (page) => window.location.href = `?page=${ page }` }
        totalPages={ conversation.pager.total_pages }
      />
    </>
  );
}

export default ViewConversation;
